import React from 'react';
import { GlassCard } from '../GlassCard';
import { GlassInput } from '../GlassInput';
import { GlassCTA } from '../GlassCTA';

interface NameStepProps {
  name: string;
  onNameChange: (name: string) => void;
  onNext: () => void;
}

export function NameStep({ name, onNameChange, onNext }: NameStepProps) {
  return (
    <GlassCard>
      <div className="flex flex-col items-center text-center">
        <h1
          className="font-display text-[28px] font-semibold text-ink tracking-tight"
        >
          What should I call you?
        </h1>

        <div className="mt-8 w-full max-w-md">
          <GlassInput
            autoFocus
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && name.trim().length >= 1) onNext();
            }}
            placeholder="Your name"
          />
        </div>

        <div className="mt-10">
          <GlassCTA onClick={onNext} disabled={name.trim().length < 1}>
            Next
          </GlassCTA>
        </div>
      </div>
    </GlassCard>
  );
}
